export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-terrain-1200-e08a83f11597330b364b6fa25f4d5ae1.webp";